export default "__VITE_ASSET__79a1259e__"